import React from "react";
import { NavLink } from "@mantine/core";
import { usePageContext } from "vike-react/usePageContext";
import { data } from "./data";

export default function ScollableLinks({ toggle }: { toggle: () => void }) {
  const { urlPathname } = usePageContext();

  return (
    <>
      {data.map((item) => {
        const hasChildren = Array.isArray(item.children);
        const isActive = item.href ? urlPathname.startsWith(item.href) : false;
        const handleParentClick = () => {
          if ((item.label === "Accessibility" || item.label === "Wall of Love") && !hasChildren) {
            toggle();
          }
        };

        return (
          <NavLink
            key={item.label}
            label={item.label}
            description={item.description}
            leftSection={item.icon ? <item.icon size={24} stroke={1.5} /> : null}
            rightSection={item.rightSection}
            active={isActive}
            defaultOpened={isActive}
            href={item.href}
            childrenOffset={28}
            variant={item.label === "Accessibility" ? "filled" : "subtle"}
            onClick={handleParentClick}
          >
            {hasChildren &&
              item.children!.map((child) => (
                <NavLink
                  key={child.label}
                  href={child.href}
                  label={child.label}
                  leftSection={child.icon ? <child.icon size={18} stroke={1.5} /> : null}
                  active={urlPathname.startsWith(child.href)}
                  onClick={() => {
                    toggle();
                  }}
                />
              ))}
          </NavLink>
        );
      })}
    </>
  );
}
